import script from "./WisdomAdminPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WisdomAdminPage.vue?vue&type=script&setup=true&lang=js"

import "./WisdomAdminPage.vue?vue&type=style&index=0&id=5c8f5f36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c8f5f36"]])

export default __exports__